import { GridCellProps } from '@progress/kendo-react-grid';
import { AdminCheckBox } from 'app/components/AdminCheckbox';
import { AdminDatePicker } from 'app/components/AdminDatePicker';
import { AdminProfileInfo } from 'app/components/AdminProfileInfo';
import { SetStateAction, useState } from 'react';
import { RiderSplitClass } from 'services/openapi';
import styled from 'styled-components';
import { isoString } from 'utils/common';

type Props = {
  className?: string;
  e: GridCellProps;
  onClick?: (e) => void;
  isDisabled?: true;
  setTransformedData?: React.Dispatch<SetStateAction<Array<any>>>;
  itemIndex?: number | undefined;
  transformedData?: any[];
  hideScratch?: boolean;
};

const SplitRiderCell = ({
  className,
  e,
  onClick,
  isDisabled,
  setTransformedData,
  itemIndex,
  transformedData,
  hideScratch,
}: Props) => {
  const data = e.dataItem;
  const dataindex = e.dataItem.index;
  let prePayload = {
    scratch: data?.scratch,
    scratchDate: data?.scratchDate || null,
  };
  const [payload, setPayload] = useState<RiderSplitClass>(prePayload);

  const name = data.firstName + ' ' + data.lastName;
  const onScratchDateChange = e => {
    const date = e.value;
    setPayload({
      ...payload,
      scratchDate: date ? date.toISOString() : null,
    });

    if (!transformedData) return;
    else {
      const mappedData = transformedData?.map((item, tindex) => {
        if (tindex === itemIndex) {
          return {
            ...item,
            riders: item.riders?.map((rider, rideIndex) => {
              if (rideIndex === dataindex) {
                return {
                  ...rider,
                  scratchDate: date ? isoString(date) : null,
                };
              }
              return rider;
            }),
          };
        }
        return item;
      });

      setTransformedData?.(mappedData);
    }
  };
  const onSplitCheckboxChange = e => {
    setPayload({
      ...payload,
      scratch: e.value,
      scratchDate: null,
    });

    if (!transformedData) return;
    else {
      const mappedData = transformedData?.map((item, tindex) => {
        if (tindex === itemIndex) {
          return {
            ...item,
            riders: item.riders?.map((rider, rideIndex) => {
              if (rideIndex === dataindex) {
                return {
                  ...rider,
                  scratch: e.value,
                  scratchDate: null,
                };
              }
              return rider;
            }),
          };
        }
        return item;
      });

      setTransformedData?.(mappedData);
    }
  };
  return (
    <StyledTd className={className ?? ''}>
      <AdminProfileInfo src={data?.riderImageUrl} name={name} />
      {!hideScratch && (
        <CheckboxSplitWrapper>
          <AdminCheckBox
            onChange={e => onSplitCheckboxChange(e)}
            value={payload.scratch}
            label="Scratch"
            className="checkbox-style"
          />
          {!isDisabled && (
            <AdminDatePicker
              placeholder="Scratch Date"
              value={
                payload.scratchDate ? new Date(payload.scratchDate) : undefined
              }
              onChange={e => onScratchDateChange(e)}
              className="field-style create-date"
              disabled={!payload.scratch}
            />
          )}
        </CheckboxSplitWrapper>
      )}
    </StyledTd>
  );
};

export default SplitRiderCell;
const StyledTd = styled.td`
  .checkbox-style {
    label {
    }
  }
`;
const CheckboxSplitWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  .custom-calendar-wrapper {
    min-height: auto;
    .k-input-solid {
      height: 31px;
      max-width: 200px;
    }
  }
`;
